export default "__VITE_ASSET__DJUG3UaO__"